"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLE_TYPES = void 0;
exports.TABLE_TYPES = [
    'regular',
    'view',
    'junction',
    'closure',
    'closure-junction',
    'entity-child'
];
//# sourceMappingURL=task-types.constants.js.map